import React, { useState, useEffect } from "react";
import { OuterContainer } from "../../EventCreation/styles";
import ActionBar from "../../common/ActionBar";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { Paper, Typography, Grid } from "@material-ui/core";
import { Formik } from "formik";
import FormField, { ButtonContainer, FormControl } from "../FormInputs";
import { PrimaryCTAButton } from "../../common/Buttons";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import { getErrorMessage } from "../../../helpers/functions";
import { navigate } from "@reach/router";
import { useTheme, useMediaQuery } from "@material-ui/core";
import _ from "lodash";

const Tickers = (id) => {
  const [items, setItems] = useState();
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));

  const inputs = [
    {
      name: "tickerText",
      label: "Ticker Text",
      type: "text",
      placeholder: "Enter ticker text",
    },
    { name: "tickerBgColor", label: "Ticker BG Color", type: "color" },
    { name: "tickerTextColor", label: "Ticker Text Color", type: "color" },
    {
      name: "tickerSpeed",
      label: "Ticker Speed",
      type: "text",
      placeholder: "Enter ticker speed",
    },
    {
      name: "specificPosition",
      label: "Specific Position",
      type: "text",
      placeholder: "Enter specific position",
    },
    {
      name: "tickerDirection",
      label: "Ticker Direction",
      type: "radio",
      menuItems: [
        { name: "leftToRight", value: "leftToRight", label: "Left to Right" },
        { name: "rightToLeft", value: "rightToLeft", label: "Right to Left" },
        { name: "alternate", value: "alternate", label: "Alternate" },
      ],
    },
    {
      name: "tickerVisibility",
      label: "Ticker Visibility",
      type: "radio",
      menuItems: [
        {
          name: "stopTheTicker",
          value: "stopTheTicker",
          label: "Remove the Ticker",
        },
        {
          name: "tickerLive",
          value: "tickerLive",
          label: "Make Ticker Live",
        },
        {
          name: "pauseTheTicker",
          value: "pauseTheTicker",
          label: "Pause the Ticker",
        },
      ],
    },
    {
      name: "tickerPosition",
      label: "Ticker Position",
      type: "radio",
      menuItems: [
        {
          name: "topOfThePage",
          value: "topOfThePage",
          label: "Top of the page",
        },
        {
          name: "bottomOfThePage",
          value: "bottomOfThePage",
          label: "Bottom of the page",
        },
        // {
        //   name: "centerOfThePage",
        //   value: "centerOfThePage",
        //   label: "Center of the page",
        // },
      ],
    },
  ];

  const custom_buttons = [
    {
      label: "PREVIEW & PUBLISH",
      color: "default",
      preview: true,
    },
    {
      label: "SAVE & PUSH LIVE",
      color: "default",
      primary: true,
    },
    {
      label: "CLEAR FORM & SAVE",
      color: "primary",
      secondary: true,
    },
    {
      label: "CLEAR FORM",
      color: "secondary",
      clearForm: true,
    },
  ];

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching event derails..." });
        const response = await EventService.getEvent(id?.id, "tickers");
        setItems(response);
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        window.scrollTo(0, 0);
        setLoader({ state: false });
      }
    }
    if (id?.id) {
      getEventInfo();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * @description Email Template submit function
   */

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = {
        isFinished: true,
        tickerSettings: {
          tickerText: values?.tickerSettings?.tickerText,
          tickerBgColor: values?.tickerSettings?.tickerBgColor,
          tickerTextColor: values?.tickerSettings?.tickerTextColor,
          tickerSpeed: values?.tickerSettings?.tickerSpeed,
          tickerDirection: values?.tickerSettings?.tickerDirection,
          tickerVisibility: values?.tickerSettings?.tickerVisibility,
          tickerPosition: values?.tickerSettings?.tickerPosition,
          specificPosition: values?.tickerSettings?.specificPosition,
        },
      };
      const response = await EventService.updateEvent(id?.id, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      navigate(`/dashboard/eventmanager/home`);
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  async function onFormSubmitPreview(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = {
        isFinished: true,
        tickerSettings: {
          tickerText: values?.tickerSettings?.tickerText,
          tickerBgColor: values?.tickerSettings?.tickerBgColor,
          tickerTextColor: values?.tickerSettings?.tickerTextColor,
          tickerSpeed: values?.tickerSettings?.tickerSpeed,
          tickerDirection: values?.tickerSettings?.tickerDirection,
          tickerVisibility: values?.tickerSettings?.tickerVisibility,
          tickerPosition: values?.tickerSettings?.tickerPosition,
          specificPosition: values?.tickerSettings?.specificPosition,
        },
      };
      const response = await EventService.updateEvent(id?.id, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      navigate(`/dashboard/eventmanager/preview/${id?.id}`);
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "event_manager":
        navigate(`/dashboard/eventmanager/home`);
        break;
      case "help":
        id?.id
          ? navigate(`/dashboard/eventmanager/help/${id?.id}`)
          : navigate(`/dashboard/eventmanager/help`);
        break;
      default:
        break;
    }
  };

  return (
    <OuterContainer disabled={false}>
      <ActionBar
        breadcrumbs={
          id?.id
            ? [
                "Event Manager",
                "Help",
                "Tickers",
                items?.eventName
                  ? `${items?.eventName} (${items?.eventDate})`
                  : "",
              ]
            : ["Event Manager", "Help", "Tickers"]
        }
        {...{ onBreadcrumbClick }}
      />
      <Container>
        <Formik
          initialValues={{
            tickerSettings: {
              tickerText: items?.tickerSettings?.tickerText || "",
              tickerBgColor: items?.tickerSettings?.tickerBgColor || "#40E0D0",
              tickerTextColor:
                items?.tickerSettings?.tickerTextColor || "#40E0D0",
              tickerSpeed: items?.tickerSettings?.tickerSpeed || "",
              tickerDirection: items?.tickerSettings?.tickerDirection || "",
              tickerVisibility: items?.tickerSettings?.tickerVisibility || "",
              tickerPosition: items?.tickerSettings?.tickerPosition || "",
              specificPosition: items?.tickerSettings?.specificPosition || "",
            },
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnBlur
          validateOnChange
          validationSchema={""}
        >
          {({
            values,
            errors,
            touched,
            resetForm,
            handleBlur,
            handleChange,
            setFieldValue,
            handleSubmit,
          }) => (
            <FormContainer>
              <Container>
                <Paper elevation={3} style={{ padding: "16px" }}>
                  <Heading>Live Tickers</Heading>
                  <Paper
                    elevation={3}
                    style={{
                      padding: 16,
                      border: "1px solid #e1e3ee",
                      marginTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <Grid
                      container
                      item
                      xs={12}
                      spacing={3}
                      style={{ padding: 16 }}
                    >
                      {inputs.map((item, idx) => (
                        <Grid
                          item
                          xs={isBigScreen ? 4 : 12}
                          key={item.name}
                          style={styles.gridItem}
                        >
                          <FormField
                            {...{
                              item,
                              handleChange,
                              values,
                              setFieldValue,
                              errors,
                            }}
                            direction={"row"}
                            value={values.tickerSettings?.[item.name]}
                            name={`tickerSettings.${item.name}`}
                            touched={`tickerSettings.${item.name}`}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                  <FormControl>
                    <ButtonContainer>
                      {custom_buttons.map((button) => (
                        <PrimaryCTAButton
                          style={{ width: "auto", marginLeft: 8 }}
                          onClick={() =>
                            button.clearForm
                              ? resetForm()
                              : button.primary
                              ? handleSubmit()
                              : button.preview
                              ? onFormSubmitPreview(values)
                              : handleSubmit()
                          }
                        >
                          {button.label}
                        </PrimaryCTAButton>
                      ))}
                    </ButtonContainer>
                  </FormControl>
                </Paper>
              </Container>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );
};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
};

export default Tickers;

const Container = styled.div`
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .delete {
    display: flex;
    cursor: pointer;
  }
  @media ${theme?.breakpoints?.sm_up} {
    // padding: 34px 43px;
  }
`;

const Heading = styled(Typography)(() => ({
  backgroundColor: "#00aeef",
  color: "#fff",
  padding: "8px",
  fontFamily: theme.fonts.primaryFontBold,
  borderRadius: "5px",
}));

const FormContainer = styled.form`
  /* width: 907px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  width: fit-content;
  @media ${theme?.breakpoints?.md_up} {
    justify-content: flex-start;
    display: flex;
    padding-bottom: 20px;
    padding-top: 7px;
  }
`;

export const DeleteIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 125px;
`;
